export * from './new-password.component';
